import React, {Component} from 'react'
import Scratch from '../Scratch/Scratch'
import scratchData from './scratchData'
import './Scratch.css'

class ScratchContainer extends Component {
  constructor() {
    super()
    this.state = {
      scratches: scratchData
    }
  }

  handleScratch(name) {
    const scratch = this.state.scratches.find(s => s.name === name)
    if (scratch.track.loaded) scratch.track.start()
  }

  render() {
    const scratches = this.state.scratches.map(scratch => (
      <Scratch 
        key={scratch.id}
        name={scratch.name}
        handleScratch={(name) => this.handleScratch(name)}
      />
    ))
    return (
      <div className='scratchContainer'>
        <div className='scratchBox'>
          {scratches}
        </div>
      </div>
    )
  }
}

export default ScratchContainer


// WEBPACK FOOTER //
// ./src/Scratch/ScratchContainer.js